(function () {
  const updateCartBadges = (count) => {
    document.querySelectorAll('.floating-cart strong').forEach((badge) => {
      badge.textContent = String(count);
    });
  };

  const fetchCart = async () => {
    const response = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Unable to fetch cart');
    return response.json();
  };

  const formatMoney = (cents) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return `$${(Number(cents || 0) / 100).toFixed(2)}`;
  };

  const countdown = document.querySelector('[data-countdown]');
  if (countdown) {
    let remaining = Number(countdown.dataset.countdown || 5400);
    const parts = countdown.querySelectorAll('[data-time-part]');
    const tick = () => {
      remaining = Math.max(0, remaining - 1);
      const days = String(Math.floor(remaining / 86400)).padStart(2, '0');
      const hours = String(Math.floor((remaining % 86400) / 3600)).padStart(2, '0');
      const minutes = String(Math.floor((remaining % 3600) / 60)).padStart(2, '0');
      const seconds = String(remaining % 60).padStart(2, '0');
      const values = parts.length === 4 ? [days, hours, minutes, seconds] : [hours, minutes, seconds];
      parts.forEach((part, index) => {
        part.textContent = values[index] || '00';
      });
    };
    tick();
    window.setInterval(tick, 1000);
  }

  document.querySelectorAll('[data-homey-slider]').forEach((slider) => {
    const slides = Array.from(slider.querySelectorAll('[data-homey-slide]'));
    const dots = Array.from(slider.querySelectorAll('[data-homey-slide-to]'));
    if (slides.length < 2) return;

    let activeIndex = 0;
    const showSlide = (nextIndex) => {
      activeIndex = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, index) => slide.classList.toggle('is-active', index === activeIndex));
      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === activeIndex));
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        showSlide(Number(dot.dataset.homeySlideTo || 0));
      });
    });

    window.setInterval(() => showSlide(activeIndex + 1), 5000);
  });

  document.querySelectorAll('.pdp-gallery').forEach((gallery) => {
    const target = gallery.querySelector('[data-main-image]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-thumb]'));
    const prev = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');
    if (!target || !thumbs.length) return;

    let activeIndex = Math.max(0, thumbs.findIndex((button) => button.classList.contains('is-active')));
    const showImage = (index) => {
      activeIndex = (index + thumbs.length) % thumbs.length;
      const activeThumb = thumbs[activeIndex];
      target.src = activeThumb.dataset.thumb;
      thumbs.forEach((item) => item.classList.remove('is-active'));
      activeThumb.classList.add('is-active');
      activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    };

    thumbs.forEach((button, index) => {
      button.addEventListener('click', () => showImage(index));
    });
    if (prev) prev.addEventListener('click', () => showImage(activeIndex - 1));
    if (next) next.addEventListener('click', () => showImage(activeIndex + 1));
  });

  document.querySelectorAll('[data-buy-now]').forEach((button) => {
    button.addEventListener('click', async () => {
      const form = button.closest('form');
      const quantityInput = form ? form.querySelector('input[name="quantity"]') : null;
      const quantity = Math.max(1, Number(quantityInput && quantityInput.value ? quantityInput.value : 1));
      const id = button.dataset.variantId;
      if (!id) return;

      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Processing...';
      try {
        await fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' });
        await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id, quantity })
        });
        window.location.href = '/checkout';
      } catch (error) {
        button.disabled = false;
        button.textContent = originalText;
        window.location.href = '/cart';
      }
    });
  });

  document.querySelectorAll('[data-ajax-cart-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('.pdp-atc');
      const message = form.querySelector('[data-cart-message]');
      const originalText = button ? button.textContent : '';
      if (button) {
        button.disabled = true;
        button.textContent = 'Adding...';
      }
      if (message) message.textContent = '';

      try {
        const formData = new FormData(form);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          body: formData
        });
        if (!response.ok) throw new Error('Unable to add product');
        const cart = await fetchCart();
        updateCartBadges(cart.item_count);
        if (message) message.textContent = 'Added to cart.';
        if (button) button.textContent = 'Added';
        window.setTimeout(() => {
          if (button) button.textContent = originalText;
          if (message) message.textContent = '';
        }, 1600);
      } catch (error) {
        if (message) message.textContent = 'Could not add. Please try again.';
        if (button) button.textContent = originalText;
      } finally {
        if (button) button.disabled = false;
      }
    });
  });

  document.querySelectorAll('[data-cart-qty]').forEach((input) => {
    let timer;
    const updateLine = async () => {
      const line = Number(input.dataset.line || 0);
      const quantity = Math.max(0, Number(input.value || 0));
      if (!line) return;

      input.disabled = true;
      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line, quantity })
        });
        if (!response.ok) throw new Error('Unable to update cart');
        const cart = await response.json();
        updateCartBadges(cart.item_count);

        const summaryTotal = document.querySelector('.cart-summary > strong');
        if (summaryTotal) summaryTotal.textContent = formatMoney(cart.total_price);

        const item = input.closest('[data-cart-line]');
        if (item) {
          const matchingItem = cart.items[line - 1];
          const linePrice = item.querySelector(':scope > strong');
          if (matchingItem && linePrice) {
            linePrice.textContent = formatMoney(matchingItem.final_line_price);
          }
          if (!matchingItem || quantity === 0) {
            item.remove();
          }
        }

        if (cart.item_count === 0) {
          window.location.reload();
        }
      } catch (error) {
        window.location.reload();
      } finally {
        input.disabled = false;
      }
    };

    input.addEventListener('input', () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(updateLine, 350);
    });
    input.addEventListener('change', () => {
      window.clearTimeout(timer);
      updateLine();
    });
  });

  document.querySelectorAll('[data-variant-option]').forEach((button) => {
    button.addEventListener('click', () => {
      const group = button.closest('[data-variant-group]');
      if (!group) return;
      group.querySelectorAll('[data-variant-option]').forEach((item) => item.classList.remove('is-selected'));
      button.classList.add('is-selected');
    });
  });
})();
